export function cleanURL (string) {
  string = string.replaceAll('https://', '').replaceAll('http://', '').replaceAll('www.', '')
  while (string.charAt(string.length - 1) === '/') {
    string = string.substring(0, string.length - 1)
  }
  return string
}
